import React from 'react';
import { formatCurrency } from '../../helpers/formatters.helpers';

interface PriceItem {
  label: string;
  amount: number;
}

interface FinancialBreakdownProps {
  items: PriceItem[];
  total?: number;
  className?: string;
}

export const FinancialBreakdown: React.FC<FinancialBreakdownProps> = ({ items, total, className = '' }) => {
  const calculatedTotal = total || items.reduce((sum, item) => sum + item.amount, 0);

  return (
    <div className={`space-y-3 ${className}`}>
      {/* Items */}
      {items.map((item, index) => (
        <div key={index} className="flex justify-between items-center text-sm">
          <span className="text-slate-600">{item.label}</span>
          <span className="font-semibold text-slate-800">{formatCurrency(item.amount)}</span>
        </div>
      ))}

      {/* Séparateur */}
      <div className="border-t-2 border-slate-200 my-4"></div>

      {/* Total */}
      <div className="flex justify-between items-center pt-2">
        <span className="text-base font-bold text-slate-900 uppercase">Total</span>
        <span className="text-xl font-bold text-slate-900">{formatCurrency(calculatedTotal)}</span>
      </div>
    </div>
  );
};
